import { render, staticRenderFns } from "./PupilsLanguages.vue?vue&type=template&id=ad2a1c26&"
import script from "./PupilsLanguages.vue?vue&type=script&lang=js&"
export * from "./PupilsLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports